import React from 'react';
import ConstructionImg from '../img/home/pfp.jpg';

const UnderConstruction = () => {
  return (
    <section className='section bg-blue-200 flex flex-col items-center justify-center text-center px-6'>
      <img src={ConstructionImg} alt='' className='max-w-[300px] mb-6' />
      <h1 className='text-3xl lg:text-5xl font-bold font-serif mb-4'>Under Construction...</h1>
      <p className='max-w-[500px] text-[#696c6d] lg:text-lg font-primary'>
        check back soon :D
      </p>
    </section>
  );
};

export default UnderConstruction;
